<template>
  <div class="video-wrap">
    <div class="video-title" v-if="item.cameraName">
      {{ item.fatherCameraName + "-" + item.cameraName}}
      <!-- <span  @click="closeVideo"></span> -->
      <!-- <button class="cutLargreen" @click="cutLargreen()">截屏</button> -->
    </div>
    <video
      class="video"
      muted
      style="object-fit: fill"
      autoplay 
      controls
      ref="player"
      :id="'videoElement' + videoIndex"
    ></video>
    <!-- <div v-else class="errow">
      此视频资源暂无法播放，请查看后再试
    </div> -->
  </div>
</template>

<script>
import Hls from "hls.js"
// import videoApi from "@/api/videoMonitorApi.js";
import dataServerApi from "../../../../request/dataServerApi";
import { Message } from "element-ui";
export default {
  name: "flvPlayer",

  props: {
    viewMode: {
      type: String
    },
    videoIndex: {
      type: Number,
      default: 0
    },
    item: {
      type: Object
    },
    streamUrl:{
      type:String,
      default:"" 
    }
  },

  data() {
    return {
      aspect: "100%",
      fluent: true,
      autoplay: true,
      showErrow: false,
      player: null
    };
  },

  created() {},

  mounted() {
    // this.loadVideo();
  },
  watch:{
    streamUrl:function(val){
    // this.createFlv(val);
    this.createHls(val);
   }
  },
  beforeUpdate() {
    // this.loadVideo();
  },
  // 一定要加这个处理，否则在切换模式和查看模式的时候
  beforeDestroy() {
    this.videoPause();
  },

  destroyed() {},

  methods: {
    //截图
    cutLargreen() {
      var player = document.getElementById("videoElement" + this.videoIndex); //获取video的Dom节点
      player.setAttribute("crossOrigin", "anonymous"); //添加srossOrigin属性，解决跨域问题
      var canvas = document.createElement("canvas");
      var img = document.createElement("img");
      canvas.width = player.clientWidth;
      canvas.height = player.clientHeight;
      canvas
        .getContext("2d")
        .drawImage(player, 0, 0, canvas.width, canvas.height); //截
      var dataURL = canvas.toDataURL("image/png"); //将图片转成base64格式
      img.src = dataURL;
      img.width = player.clientWidth - 200; //控制截出来的图片宽的大小
      img.height = player.clientHeight - 200; //控制截出来的图片高的大小
      img.style.border = "1px solid #333333"; //控制截出来的图片边框的样式
      let imgName =
        this.item.districtName +
        "-" +
        this.item.culturaCompanyName +
        "-" +
        this.item.name +
        new Date().getTime() +
        ".jpg";
      this.downFile(dataURL, imgName); //下载截图
    },

    //下载截图
    downFile(data, fileName) {
      var save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      ); //有效的内部空间URI
      save_link.href = data;
      save_link.download = fileName;
      var event = document.createEvent("MouseEvents");
      event.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      save_link.dispatchEvent(event);
    },
    destoryVideo() {
      if (this.player) {
        this.player.pause();
        this.player.unload();
        this.player.detachMediaElement();
        this.player.destroy();
        this.player = null;
      }
    },
    closeVideo() {
      let index = this.item.index;
      let item = Object.assign({}, this.item);
      this.$emit("destoryVideo", item);
      this.destoryVideo();
    },
    createHls(uri){
      const that= this
      this.hls = new Hls()
      const video = this.$refs.player;
      this.hls.attachMedia(video)
      this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        that.hls.loadSource(uri)
      })
      this.hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        video.play()
      });
      this.hls.on(Hls.Events.ERROR, (event, data) => {
            // console.log(event, data);
            // 监听出错事件
            console.log('加载失败');
            that.createHls(that.streamUrl)
          });

    },
    startPlay(){
      const video = this.$refs.player;
      video.play();
    },
    pausePlay(){
      const video = this.$refs.player;
      video.pause();
    },
    videoPause() {
      if (this.hls) {
        this.$refs.player.pause();
        this.hls.destroy();
        this.hls = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.player-wrapper {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
  padding-bottom: 0 !important;
}
.video-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  .video {
    width: 100%;
    height: 100%;
  }
}
.video-wrap,
.video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
}
.video-title {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 40/1080 * 100vh;
  padding: 0 20/100 * 1rem;
  font-size: 226/100 * 1rem;
  line-height: 50/1080 * 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  text-indent: 2em;
  span {
    position: absolute;
    right: 10px;
    top: 8px;
    width: 20/1080 * 100vh;
    height: 20/1080 * 100vh;
    // background: red;
    background: url("../theme-default/src/images/close.png") no-repeat center center;
    background-size: 15/1080 * 100vh 15/1080 * 100vh;
    cursor: pointer;
  }
}
.errow {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.vjs-custom-skin > .video-js {
  height: 100%;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  height: 1.4em !important;
  line-height: 1.4em !important;
}

.cutLargreen {
  margin-left: 1em;
  padding: 0.2em 0.5em;
}
</style>